export const ka = {
    LEFT: 'დატოვა: გადავა წინა დღე.',
    RIGHT: 'Right: გადაადგილება, რათა მომდევნო დღეს.',
    DOWN: 'Down: გადაადგილება, რათა მომდევნო გრაფაში.',
    UP: 'Up: გადავა წინა row.',
    PGUP: 'PgUp: გადავა წინა თვე.',
    PGDOWN: 'PgDown: გადაადგილება, რათა მომდევნო თვეში.',
    HOME: 'მთავარი: გადავა წინა წელს.',
    END: 'End: გადავა მომდევნო წელს.',
    ESC: 'Esc/დღეს/Close დახურვა კალენდარი.',
    TITLE: 'Keyboard ინსტრუქცია'
};
